// A page that does not exist (admin-d.md F, APS-481): inside the shell, a PageHead, one quiet
// line and the way back to the overview. Outside the shell (signed out), the same page alone.
import { EmptyNote, PageHead } from '@apsio/ui'
import { Link } from '@tanstack/react-router'
import { useCrumbs } from '../components/Shell'
import { useI18n } from '../i18n'

export function NotFoundPage() {
  const { t } = useI18n()
  useCrumbs([{ label: t('notFound.title') }])
  return (
    <main id="main" className="pg">
      <PageHead title={t('notFound.title')} />
      <EmptyNote title={t('notFound.body')}>
        <Link to="/overview">{t('notFound.back')}</Link>
      </EmptyNote>
    </main>
  )
}
